module.exports = __webpack_public_path__ + "static/media/Nlogo.8e1001ce.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Nlogo.png
 ** module id = 35
 ** module chunks = 0
 **/